import React from "react";

/**
 * Inline SVG country flags — rendered identically on every browser/OS.
 * Each flag is drawn on a 24x18 viewBox with rounded corners and a subtle border
 * so it sits nicely on both light and dark surfaces.
 *
 * Codes follow the i18n language code (es, en, it, pt). For English we use
 * the United Kingdom flag (since the user base is European).
 */

const Box = ({ children, ringClass = "" }) => (
  <span
    className={`inline-block overflow-hidden rounded-[3px] align-middle shadow-[inset_0_0_0_0.5px_rgba(15,23,42,0.18)] ${ringClass}`}
    style={{ width: 22, height: 16, lineHeight: 0 }}
  >
    <svg viewBox="0 0 24 18" width="22" height="16" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      {children}
    </svg>
  </span>
);

const FlagES = () => (
  <Box>
    <rect width="24" height="18" fill="#C60B1E" />
    <rect y="4.5" width="24" height="9" fill="#FFC400" />
  </Box>
);

const FlagGB = () => (
  <Box>
    {/* Blue base */}
    <rect width="24" height="18" fill="#012169" />
    {/* White diagonals */}
    <path d="M0 0 L24 18 M24 0 L0 18" stroke="#FFFFFF" strokeWidth="3.6" />
    {/* Red diagonals (split to avoid overlap on St Patrick) */}
    <path d="M0 0 L24 18" stroke="#C8102E" strokeWidth="1.8" />
    <path d="M24 0 L0 18" stroke="#C8102E" strokeWidth="1.8" />
    {/* White cross */}
    <path d="M12 0 V18 M0 9 H24" stroke="#FFFFFF" strokeWidth="4.5" />
    {/* Red cross */}
    <path d="M12 0 V18 M0 9 H24" stroke="#C8102E" strokeWidth="2.4" />
  </Box>
);

const FlagIT = () => (
  <Box>
    <rect width="8" height="18" x="0"  fill="#009246" />
    <rect width="8" height="18" x="8"  fill="#FFFFFF" />
    <rect width="8" height="18" x="16" fill="#CE2B37" />
  </Box>
);

const FlagPT = () => (
  <Box>
    <rect width="9.6" height="18" x="0" fill="#006600" />
    <rect width="14.4" height="18" x="9.6" fill="#CC0000" />
    {/* Shield disc */}
    <circle cx="9.6" cy="9" r="3.2" fill="#FFD800" stroke="#000" strokeWidth="0.2" />
    <circle cx="9.6" cy="9" r="2" fill="#FFFFFF" stroke="#000" strokeWidth="0.2" />
    <rect x="8.4" y="7.8" width="2.4" height="2.4" fill="#003399" />
  </Box>
);

const REGISTRY = { es: FlagES, en: FlagGB, it: FlagIT, pt: FlagPT };

export default function Flag({ code = "es", className = "" }) {
  const Cmp = REGISTRY[code] || REGISTRY.es;
  return (
    <span className={`inline-flex items-center justify-center ${className}`}>
      <Cmp />
    </span>
  );
}
